import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  open(event) {
    event.preventDefault()
    const targetId = event.params.target
    const modalElement = document.getElementById(targetId)
    if (!modalElement) return

    // Numbered wheel dots carry wheel/wheelLabel params. The add modal's
    // form fields don't exist yet at this point — single-scale-modal
    // clones them from a <template> on shown.bs.modal — so the wheel is
    // stamped on the modal element and applied after the clone (see
    // single_scale_modal_controller#ensureOne). The title lives outside
    // the template and can update immediately. Readings modals for
    // existing usages are never touched.
    if (targetId.endsWith("-add-modal")) {
      const draft = modalElement.querySelector(".scale-usage")
      const previousWheel = draft?.querySelector("[data-wheel-field]")?.value
      const nextWheel = String(event.params.wheel ?? "")
      const hasDraft = draft && (draft.querySelector(".reading-thumb") ||
        Array.from(draft.querySelectorAll("input:not([type=hidden]), select, textarea"))
          .some((field) => field.value.trim() !== ""))
      const notice = modalElement.querySelector("[data-scale-draft-notice]")
      if (hasDraft && previousWheel !== nextWheel) {
        if (notice) {
          notice.textContent = `Save the unsaved scale for ${previousWheel ? `wheel ${previousWheel}` : "this gear"} before assigning ${nextWheel ? `wheel ${nextWheel}` : "another platform"}. Closing the dialog keeps these edits.`
          notice.hidden = false
        }
        Modal.getOrCreateInstance(modalElement).show()
        return
      }
      if (notice) notice.hidden = true
      modalElement.dataset.pendingWheel = event.params.wheel ?? ""
      const title = modalElement.querySelector("[data-wheel-title]")
      if (title) title.textContent = `— ${event.params.wheelLabel ?? "Whole-gear platform"}`
    }

    // Grey out scales other wheels already hold, once the dialog's fields
    // exist (the add dialog clones them on shown.bs.modal, registered
    // earlier, so this listener runs after).
    modalElement.addEventListener("shown.bs.modal", () => this.markTakenScales(modalElement), { once: true })
    Modal.getOrCreateInstance(modalElement).show()
  }

  // A scale can be on one wheel at a time (the server refuses otherwise).
  // Every wheel's scale select is in this form, so the dialog being opened
  // disables the scales the OTHER wheels hold and says which wheel has
  // them. Scales the server already disabled (expired calibration) stay
  // disabled; labels are restored from their original text each time.
  markTakenScales(modalElement) {
    const select = modalElement.querySelector("select[name$='[scale_id]']")
    if (!select) return
    const ownUsage = select.closest(".scale-usage")

    const taken = new Map()
    document.querySelectorAll(".scale-usage").forEach((usage) => {
      if (usage === ownUsage) return
      if (usage.querySelector("input[name$='[_destroy]']")?.value === "1") return
      const other = usage.querySelector("select[name$='[scale_id]']")
      if (!other?.value) return
      const wheel = usage.querySelector("[data-wheel-field]")?.value
      taken.set(other.value, wheel ? `on wheel ${wheel}` : "on another gear")
    })

    Array.from(select.options).forEach((option) => {
      if (!option.value) return
      if (option.dataset.baseLabel === undefined) {
        option.dataset.baseLabel = option.textContent
        option.dataset.baseDisabled = option.disabled ? "1" : "0"
      }
      const where = taken.get(option.value)
      option.disabled = option.dataset.baseDisabled === "1" || Boolean(where)
      option.textContent = where ? `${option.dataset.baseLabel} · ${where}` : option.dataset.baseLabel
    })
  }
}
